<template>
  <div class="yunxiao teacher types-choose-new">
    <div class="top-container flex-between">
      <div class="left">
        <div class="title">请选择您的业务类型</div>
        <div class="desc">为了帮助你的机构更好的进行经营管理，请选择机构的业务类型范围（可多选）</div>
      </div>
      <div class="right">
        <div class="btn-like flex-center" v-if="!isEdit" @click="$router.back()">上一步</div>
      </div>
    </div>

    <div class="content">
      <div class="category-container" v-for="category in list" :key="category.category">
        <div class="category">
          <svg class="title-icon">
            <use :xlink:href="iconMap[category.category]"></use>
          </svg>
          <van-icon prefix="vxm-icon" :name="iconMap[category.category]"></van-icon>
          {{ category.category }}
        </div>
        <div class="type-list">
          <div
            class="type-item flex-center"
            :class="{ active: choosedTypes.includes(typeItem) }"
            v-for="typeItem in category.typeList"
            :key="typeItem.key"
            @click="choiceTypes(typeItem)"
          >
            {{ typeItem.value }}
          </div>
        </div>
      </div>
    </div>

    <pageFooterBtn :btnText="`${choosedTypes.length === 0 ? '' : `（已选${choosedTypes.length}个）`}确认创建`" @click="submit" v-if="!isEdit"  ></pageFooterBtn>
    <pageFooterBtn multipleBtns v-else>
      <van-button
        square
        round
        block
        class="cancel"
        @click="cancelConfirm"
      >
        取消
      </van-button>
      <van-button
        square
        round
        block
        type="primary"
        @click="changeSubmit"
      >
        <template v-if="choosedTypes.length">
          （已选{{choosedTypes.length}}个）
        </template>
        确定
      </van-button>
    </pageFooterBtn>
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';

const iconMap = {
  体育: '#vxm-icon-tiyu',
  艺术: '#vxm-icon-yishu',
  科创: '#vxm-icon-kechuang',
  学科: '#vxm-icon-xueke',
  其他: '#vxm-icon-qita',
};

export default {
  name: 'OrganizationTypesChoosed',
  components: {
    pageFooterBtn,
  },
  data() {
    return {
      cl:'#8070F5',
      iconMap,
      pageTitle: '选择业务类型',
      choosedTypes: [],
      list: [],
      isEdit: this.$route.query.from === 'edit',
      fromLogin: false,
    };
  },
  async created() {
    if (this.$route.query.from === 'login') {
      this.fromLogin = true;
    }
    const res = await this.$api.getCustomerTypeAndCategory();
    this.list = res.data;
    if (this.$route.query.keys) {
      let keys = this.$route.query.keys.split(',');
      this.list.forEach(category => {
        category.typeList.forEach(type => {
          if (keys.includes(type.key)){
            this.choosedTypes.push(type);
          }
        });
      });
    }
  },
  mounted() {},
  methods: {
    choiceTypes(item) {
      let idx = this.choosedTypes.findIndex(v => v === item);
      idx >= 0 ? this.choosedTypes.splice(idx, 1) : this.choosedTypes.push(item);
    },
    cancelConfirm() {
      this.$router.back();
    },
    changeSubmit() {
      app.vue.$emit('organizationTypesChoosed', this.choosedTypes);
      this.$router.back();
    },
    async submit() {
      if (!this.choosedTypes.length) {
        this.$toast('请选择业务类型...');
        return false;
      }
      try {
        let api = this.$api.companyAddCompany;
        let params = {
          phone: app.teacher.user.phone,
          companyName: this.$route.query.companyName,
          contactPerson: this.$route.query.contactPerson,
          // customerTypeList后端需要转换一下；
          customerTypeList: this.choosedTypes.map(v => ({
            customerTypeId: v.key,
            customerTypeName: v.value,
          })),
          addSameCompanyName: false,
        };
        this.showLoading();
        let res = await api(params);

        if (res.code === 200 && res.msg === '成功') {
          this.$toast.clear();
          this.$router.replace(`/baseOrganizationInit?id=${res.data}&fromLogin=${+this.fromLogin}`);
        } else {
          this.$toast.clear();
          // 同名机构注册提示
          if (res.code === 720003) {
            this.$dialog
              .confirm({
                title: '提示',
                message: `已经存在同名机构“${this.$route.query.companyName}”，请确认是否继续新增？`,
                confirmButtonText: '确认新增',
                cancelButtonText: '取消',
                confirmButtonColor: '#8070F5'
              })
              .then(() => {
                this.showLoading();
                params.addSameCompanyName = true;
                api(params)
                  .then(ret => {
                    if (ret.code === 200 && ret.msg === '成功') {
                      this.$toast.clear();
                      this.$router.replace(`/baseOrganizationInit?id=${ret.data}&fromLogin=${+this.fromLogin}`);
                    }
                  })
                  .finally(() => {
                    this.$toast.clear();
                  });
              })
              .catch(() => {});
          }
        }
      } catch (err) {
        console.log('创建机构接口出错。', err);
      }

    },
  },
};
</script>

<style lang="scss" >
.yunxiao.teacher.types-choose-new {
  display: flex;
  flex-direction: column;
  // background-color: var(--g2);
 background: #FFFFFF;
  .top-container {
    padding: 21px 16px 12px;
    .left {
      width: 255px;
      .title {
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        font-weight: var(--bold);
        margin-bottom: 4px;
        color: var(--g8);
        .desc {
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          color: var(--g6);
        }
      }
    }
    .right {
      .btn-like {
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
        color: var(--g8);
        padding: 4px 8px;
        border-radius: 4px;
        border: 1px solid var(--g5);
      }
    }
  }
  .content {
    height: calc(100vh - 150px);
    overflow: auto;
    .category-container {
      .category {
        height: 44px;
        background: var(--white);
        display: flex;
        align-items: center;

        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: var(--g8);
        padding-left: 18px;
        .title-icon {
          width: 20px;
          height: 20px;
          margin-right: 6px;
        }
      }
      .type-list {
        padding: 12px 16px 20px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-row-gap: 16px;
        justify-items: center;
        .type-item {
          border-radius: 4px;
          color: var(--g8);
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          flex: 0 0 auto;
          width: 76px;
          height: 32px;
          background: var(--g1);  
          &.active {
            background: rgba(128, 112, 245, 0.12);
            color: #8070F5;
            font-weight: var(--bold);
          }
        }
      }
    }
  }
  .van-button--primary{
     background-color:  #8070F5;
     border: 1px solid #8070F5;
  }
}
</style>
